import {DropdownMultiselectCreatable} from '@nt/dds-multiselect';
import React, {useEffect} from "react";
import {selectReleaseToggles} from "src/ReleaseToggles/releaseTogglesSlice";
import {useAppSelector} from "src/store/hooks";
import {NO_OP} from "../../../../constants/common";
import {isValid} from "../../../validation/ValidationUtils";

type DropdownMultiselectProps = {
    alignRight?: boolean,
    creatable?: boolean,
    disabled?: boolean,
    dropUp?: boolean,
    dynamicDropAlign?: boolean,
    dynamicDropDirection?: boolean,
    error?: string,
    hideSelectAll?: boolean,
    id?: string,
    label?: string,
    onChange?: Function,
    onBlur?: Function,
    open?: boolean,
    options?: object,
    panelHeight?: number,
    panelWidth?: string,
    placeholder?: string,
    required?: boolean,
    searchable?: boolean,
    selectAllLabel?: string,
    selected?: object,
    selectedDisplayTextAfter?: string,
    selectedDisplayTextBefore?: string,
    selectedItemsFirst?: boolean,
    showClearAllButton?: boolean,
    showFullSelected?: boolean,
    showTotalSelected?: boolean,
    className?: string,
    helperText?: string
}

const DropdownMultiselect = ({
                                 alignRight = false,
                                 creatable = true,
                                 disabled = false,
                                 dropUp = false,
                                 dynamicDropAlign = false,
                                 dynamicDropDirection = false,
                                 error,
                                 hideSelectAll,
                                 id,
                                 label,
                                 onChange = NO_OP,
                                 onBlur = NO_OP,
                                 open = false,
                                 options = {},
                                 panelHeight = 280,
                                 panelWidth = "100%",
                                 placeholder,
                                 required = false,
                                 searchable = false,
                                 selectAllLabel,
                                 selected = {},
                                 selectedDisplayTextAfter,
                                 selectedDisplayTextBefore,
                                 selectedItemsFirst = false,
                                 showClearAllButton = false,
                                 showFullSelected = false,
                                 showTotalSelected = false,
                                 className = "",
                                 helperText = ""
                             }: DropdownMultiselectProps) => {

    useEffect(() => {
        const handleDocumentKeystroke = (e: any) => {
            if (e.target && e.target.name === `${id}-DropdownField`) {
                if (!isValid(e.target.value) && e.key === " ") {
                    e.target.value = "";
                    e.preventDefault();
                }
            }
        };
        document.addEventListener('keydown', handleDocumentKeystroke);
        return () => {
            document.removeEventListener('keydown', handleDocumentKeystroke);
        };
    }, []);
    const releaseToggles = useAppSelector(selectReleaseToggles);

    // Helper to build stateList from selected and options
    function buildStateList(selected: any[], options: any[]) {
        if (!Array.isArray(selected)) return [];
        if (!Array.isArray(options)) {
            return selected.map((val: string) => ({ value: val, label: '', selected: true }));
        }
        return selected.map((val: string) => {
            const match = options.find((opt: any) => opt.value === val);
            if (match) {
                return { ...match, selected: true };
            }
            return { value: val, label: '', selected: true };
        });
    }

    // Helper to retain order of selection
    function getOrderedList(prevList: any[], newList: any[]) {
        const retained = prevList.filter(
            (item: any) => newList.some((l: any) => l.value === item.value)
        );
        const added = newList.filter(
            (item: any) => !prevList.some((s: any) => s.value === item.value)
        );
        return [...retained, ...added];
    }

    const [stateList, setStateList] = React.useState<any[]>(buildStateList(selected as any[], options as any[]));

    return (
        <>
            <DropdownMultiselectCreatable
                className={className}
                alignRight={alignRight}
                creatable={creatable}
                disabled={disabled}
                dropUp={dropUp}
                dynamicDropAlign={dynamicDropAlign}
                dynamicDropDirection={dynamicDropDirection}
                error={error}
                hideSelectAll={hideSelectAll}
                id={id}
                label={label}
                onChange={(list: any) => {
                    if (releaseToggles?.enableEstateFlowchartMVPRelease) {
                        const builtList = buildStateList(list.map((item: any) => item.value), options as any[]);
                        const currList = getOrderedList(stateList, builtList);
                        setStateList(currList);
                        onChange(currList);
                    } else {
                        onChange(list)
                    }
                }}
                onBlur={onBlur}
                open={open}
                options={options}
                panelHeight={panelHeight}
                panelWidth={panelWidth}
                placeholder={placeholder}
                required={required}
                searchable={searchable}
                selectAllLabel={selectAllLabel}
                selected={selected}
                selectedDisplayTextAfter={selectedDisplayTextAfter}
                selectedDisplayTextBefore={selectedDisplayTextBefore}
                selectedItemsFirst={selectedItemsFirst}
                showClearAllButton={showClearAllButton}
                showFullSelected={showFullSelected}
                showTotalSelected={showTotalSelected}
            />
            {!error && <span className="input__info margintop-sm">{helperText}</span>}
        </>
    )
}

export default DropdownMultiselect;
